import React from "react";
import { Card, CardBody, } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import { labelStyles } from "views/pages/manage/masters/studentFinancials/chargeModifications/constants";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { FILTER__FORM_FIELDS_GLOBAL, hardcodeDropdown } from "./constants";

const FilterForm = ({
    closePopup,
    dropdownData,
    filterForm,
    setFilterForm,
    filterCount,
    setFilterCount,
    applyFilterHandler,
    filterFormHandler,
    buTypeChangeHandler,
    buLoading
}) => {

    const resetFilterForm = () => {
        setFilterCount(0);
        setFilterForm({ ...FILTER__FORM_FIELDS_GLOBAL });
        applyFilterHandler();
        closePopup();
    };

    const { businessArea } = dropdownData;

    const handleApplyFilter = () => {
        let fCount = getFilterCount({ ...filterForm }, ["gstType"]);
        setFilterCount(fCount);
        applyFilterHandler(filterForm);
        closePopup();
    };

    return (
        <Card
            className="mb-0 regular-body label-color"
            style={{ width: "330px", borderRadius: "12px" }}
        >
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                </div>

                <div className="d-flex flex-column gap-md">

                    <AAutoComplete
                        label="Business Unit"
                        currentValue={filterForm?.businessArea}
                        items={businessArea}
                        handleChange={(value) => {
                            filterFormHandler("businessArea", value);
                        }}
                        isMulti={true}
                    />

                    <div style={labelStyles}>Invoice Number</div>
                    <AInput
                        type="text"
                        value={filterForm?.invoiceNumber}
                        handler={(value) => {
                            filterFormHandler("invoiceNumber", value);
                        }}
                        placeholder="Enter"
                    />

                    <div style={labelStyles}>Application Id</div>
                    <AInput
                        type="text"
                        value={filterForm?.applicationId}
                        handler={(value) => {
                            filterFormHandler("applicationId", value);
                        }}
                        placeholder="Enter"
                    />

                    <div style={labelStyles}>Student ID (EMPLID)</div>
                    <AInput
                        type="text"
                        value={filterForm?.psid}
                        handler={(value) => {
                            filterFormHandler("psid", value);
                        }}
                        placeholder="Enter"
                    />

                    <AAutoComplete
                        label="Third Party Status"
                        currentValue={filterForm?.thirdPartyStatus}
                        items={hardcodeDropdown?.thirdPartyStatus}
                        handleChange={(value) => {
                            filterFormHandler("thirdPartyStatus", value);
                        }}
                        isMulti={false}
                    />

                    <div style={labelStyles}>Transaction Date</div>
                    <div className={"d-flex flex justify-content-between"} style={{ columnGap: '10px' }}>
                        <CustomDatePickerV2
                            placeHolder="From"
                            maxDate={moment(new Date())}
                            value={filterForm?.fromDate}
                            width={"18px"}
                            handler={(index, date, keyName) => {
                                filterFormHandler("fromDate", moment(date).startOf('day'));
                                filterFormHandler("toDate", moment(new Date()).endOf('day'));
                            }}
                        />
                        <CustomDatePickerV2
                            placeHolder="To"
                            width={"18px"}
                            maxDate={moment(new Date())}
                            value={filterForm?.toDate}
                            handler={(index, date, keyName) => {
                                filterFormHandler("toDate", moment(date).endOf('day'));
                            }}
                        />
                    </div>
                </div>
                <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                    <AButton
                        variant="primary_filled"
                        className="button_remove_left_margin"
                        onClick={() => {
                            handleApplyFilter();
                        }}
                        disabled={getFilterCount({ ...filterForm }) == 0}
                    >
                        Apply filter
                    </AButton>

                    {filterCount > 0 && (
                        <AButton
                            variant="outline"
                            className="button_remove_left_margin"
                            updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                            onClick={resetFilterForm}
                        >
                            Remove filter
                        </AButton>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default FilterForm;